import React from 'react';

const IconHome = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 8C6.29052 8 5.28164 7.14112 5.05001 6H2.5C2.22386 6 2 5.77614 2 5.5C2 5.22386 2.22386 5 2.5 5H5.05001C5.28164 3.85888 6.29052 3 7.5 3C8.70948 3 9.71836 3.85888 9.94999 5H21.5C21.7761 5 22 5.22386 22 5.5C22 5.77614 21.7761 6 21.5 6H9.94999C9.71836 7.14112 8.70948 8 7.5 8ZM2 11.5C2 11.7761 2.22386 12 2.5 12H13.05C13.2816 13.1411 14.2905 14 15.5 14C16.7095 14 17.7184 13.1411 17.95 12H21.5C21.7761 12 22 11.7761 22 11.5C22 11.2239 21.7761 11 21.5 11H17.95C17.7184 9.85888 16.7095 9 15.5 9C14.2905 9 13.2816 9.85888 13.05 11H2.5C2.22386 11 2 11.2239 2 11.5ZM2 17.5C2 17.7761 2.22386 18 2.5 18H6.05001C6.28164 19.1411 7.29052 20 8.5 20C9.70948 20 10.7184 19.1411 10.95 18H21.5C21.7761 18 22 17.7761 22 17.5C22 17.2239 21.7761 17 21.5 17H10.95C10.7184 15.8589 9.70948 15 8.5 15C7.29052 15 6.28164 15.8589 6.05001 17H2.5C2.22386 17 2 17.2239 2 17.5ZM9 5.5C9 6.32843 8.32843 7 7.5 7C6.67157 7 6 6.32843 6 5.5C6 4.67157 6.67157 4 7.5 4C8.32843 4 9 4.67157 9 5.5ZM15.5 13C16.3284 13 17 12.3284 17 11.5C17 10.6716 16.3284 10 15.5 10C14.6716 10 14 10.6716 14 11.5C14 12.3284 14.6716 13 15.5 13ZM10 17.5C10 18.3284 9.32843 19 8.5 19C7.67157 19 7 18.3284 7 17.5C7 16.6716 7.67157 16 8.5 16C9.32843 16 10 16.6716 10 17.5Z"
        fill="white"
      />
    </svg>
  );
};

export default IconHome;
